<div [class]="withVerticalScroll ? 'table-responsive tableFixHead' : 'table-responsive'">
	<table class="table table-borderless">
		<thead>
			<ng-content select="[additionalHeaders]"></ng-content>
			<tr>
				<th *ngIf="withCheckBox" class="col-actions">
					<label *ngIf="selectAll" class="custom-checkbox custom-checkbox-sm" style="display: contents !important">
						<input type="checkbox" [checked]="isAllRowsCheked" (click)="selectAllRows($event)" />
						<span class="label-text"></span>
					</label>
					<ng-content select="[totalSelection]"></ng-content>
				</th>
				<ng-container *ngFor="let column of columnSettings">
					<th
						*ngIf="column.display !== false"
						[class]="column.isSorted ? column.class + ' col-sortable ' : column.class"
						[ngClass]="column.isSorted ? getSortClasses(column.name) : ''"
						(click)="column.isSorted ? onSetSort(column.name) : null"
						container="body"
						position="top"
						boundariesElement="window"
						[matTooltip]="column.withHeaderTootip && column.headerTootipText ? column.headerTootipText : ''"
					>
						<span [class]="column.withHeaderTootip && column.headerTootipText ? 'disabled-th' : ''">
							{{ translationPath + '.' + column.name | translate }}
						</span>
					</th>
				</ng-container>

				<th class="col-actions" *ngIf="withActions && (actionPermission | hasPermission)"></th>
			</tr>
		</thead>
		<tbody>
			<!-- trackBy: trackColumnById -->
			<tr
				*ngFor="let item of list?.items; let i = index; trackBy: trackColumnById"
				[attr.id]="rowIdPrefix + '-' + i"
				[class]="'table-row' + ((selectedRow === i || _highlightedOpIds?.includes(item.operationId)) ? ' selected' : '')"
				[matTooltip]="item.rowTooltip"
			>
				<ng-container *ngIf="withCheckBox">
					<td class="align-middle" *ngIf="specialCheckbox; else classicCheckbox">
						<ng-container *ngTemplateOutlet="SpecialCheckboxTreatement; context: { colname: col, row: item }"> </ng-container>
					</td>

					<ng-template #classicCheckbox>
						<td>
							<label class="custom-checkbox custom-checkbox-sm" style="display: contents !important">
								<input
									type="checkbox"
									[checked]="isAllRowsCheked || item.isChecked"
									(click)="onCheckItem(item, $event)"
									[disabled]="isAllRowsCheked"
								/>
								<span class="label-text"></span>
							</label>
						</td>
					</ng-template>
				</ng-container>

				<ng-container *ngFor="let col of columnSettings">
					<td
						*ngIf="!col.isBoolean && !col.isSpecialColumn && !col.withHeaderTootip && !col.withTooltip; else toggleItem"
						[class]="col.class"
						(click)="selectRow(i, item)"
						(dblclick)="onDoubleClickRow(i, item)"
					>
						<span *ngIf="col.isAmount !== true"> {{ item[col.name] ? item[col.name] : '-' }}</span>
						<span *ngIf="col.isAmount === true">{{ item[col.name] | number: '4.1-5' : 'fr' }}</span>
					</td>

					<ng-template #toggleItem>
						<td
							*ngIf="!col.isBoolean && col.isSpecialColumn && !col.withHeaderTootip && !col.withTooltip && (col.display !== false)"
							[class]="col.class"
							(click)="selectRow(i, item)"
							(dblclick)="onDoubleClickRow(i, item)"
						>
							<ng-container
								*ngTemplateOutlet="
									SpecialColumnTreatement;
									context: { $implicit: item[col.name], colname: col, row: item, index: i }
								"
							>
							</ng-container>
						</td>
						<td *ngIf="col.isBoolean" class="col-enable" (click)="selectRow(i, item)" (dblclick)="onDoubleClickRow(i, item)">
							<btn-toggle [isStatic]="true" [checked]="item[col.name]"> </btn-toggle>
						</td>
						<td
							*ngIf="!col.isBoolean && (col.withHeaderTootip || col.withTooltip)"
							[class]="col.class"
							(click)="selectRow(i, item)"
							(dblclick)="onDoubleClickRow(i, item)"
						>
							<span [matTooltip]="item[col.name]" container="body" position="top" boundariesElement="window">
								{{ item[col.name] }}
							</span>
						</td>
					</ng-template>
				</ng-container>

				<td class="col-actions" *ngIf="withActions && (actionPermission | hasPermission)">
					<datagrid-actions-dropdown [stopPropagation]="selectedRow === i ? true : false">
						<ng-container *ngTemplateOutlet="buttonActions; context: { $implicit: item }"></ng-container>
					</datagrid-actions-dropdown>
				</td>
			</tr>
			<tr *ngIf="list?.items.length === 0" datagrid-row-empty [colspan]="16"></tr>
		</tbody>
	</table>
</div>

<datagrid-paging
	*ngIf="withPagination === true && list?.items.length > 0"
	[list]="list"
	[settings]="getCurrentConfig()"
	[withNewParam]="true"
	(changePagingParam)="dispatchNewSettings($event)"
>
</datagrid-paging>
